var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{staticClass:"message-block all:flex align-start gap-2",class:`message-block__${_vm.type}`},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_c('div',{staticClass:"content all:flex flex-column text-12 leading-tight"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }